import { useState } from 'react'
import { DateRange } from 'react-day-picker'
import { format, startOfMonth, endOfMonth } from 'date-fns'

type UseDateRangeProps = {
  defaultFrom?: Date
  defaultTo?: Date
}

export function useDateRange({ defaultFrom, defaultTo }: UseDateRangeProps = {}) {
  const today = new Date()

  const [dateRange, setDateRange] = useState<DateRange>({
    from: defaultFrom ?? startOfMonth(today),
    to: defaultTo ?? endOfMonth(today),
  })

  const formattedRange = {
    startDate: dateRange.from ? format(dateRange.from, 'yyyy-MM-dd HH:mm:ss.SSSSSS') : '',
    endDate: dateRange.to ? format(dateRange.to, 'yyyy-MM-dd HH:mm:ss.SSSSSS') : '',
  }

  return {
    dateRange,
    setDateRange,
    formattedRange,
  }
}
